const actionTypesPrefix = "analysisTemplate";
const analysisTemplateActionTypes = {
  SET_ROUTE_CONTEXT: `${actionTypesPrefix}/SET_ROUTE_CONTEXT`,
  SET_USER_CONTEXT: `${actionTypesPrefix}/SET_USER_CONTEXT`,
  SET_PARTIAL_USER_CONTEXT: `${actionTypesPrefix}/SET_PARTIAL_USER_CONTEXT`,
  LOAD_TEMPLATE_ABSTRACTS: `${actionTypesPrefix}/LOAD_TEMPLATE_ABSTRACTS`,
  LOADING_TEMPLATE_ABSTRACTS: `${actionTypesPrefix}/LOADING_TEMPLATE_ABSTRACTS`,
  LOADED_TEMPLATE_ABSTRACTS: `${actionTypesPrefix}/LOADED_TEMPLATE_ABSTRACTS`,
  LOAD_TEMPLATE: `${actionTypesPrefix}/LOAD_TEMPLATE`,
  LOADING_TEMPLATE: `${actionTypesPrefix}/LOADING_TEMPLATE`,
  LOADED_TEMPLATE: `${actionTypesPrefix}/LOADED_TEMPLATE`,
  SAVE_TEMPLATE: `${actionTypesPrefix}/SAVE_TEMPLATE`,
  SAVING_TEMPLATE: `${actionTypesPrefix}/SAVING_TEMPLATE`,
  SAVED_TEMPLATE: `${actionTypesPrefix}/SAVED_TEMPLATE`,
  CREATE_TEMPLATE: `${actionTypesPrefix}/CREATE_TEMPLATE`,
  CREATING_TEMPLATE: `${actionTypesPrefix}/CREATING_TEMPLATE`,
  CREATED_TEMPLATE: `${actionTypesPrefix}/CREATED_TEMPLATE`,
  REGISTER_DATA_SOURCE: `${actionTypesPrefix}/REGISTER_DATA_SOURCE`,
  REGISTERING_DATA_SOURCE: `${actionTypesPrefix}/REGISTERING_DATA_SOURCE`,
  REGISTERED_DATA_SOURCE: `${actionTypesPrefix}/REGISTERED_DATA_SOURCE`,
  SET_TEMPLATE_EDIT_CONTENT: `${actionTypesPrefix}/SET_TEMPLATE_EDIT_CONTENT`,
  // really used after saving a new template
  NAVIGATE_TO_TEMPLATE: `${actionTypesPrefix}/NAVIGATE_TO_TEMPLATE`,
  TOGGLE_EDITOR_THEME: `${actionTypesPrefix}/TOGGLE_EDITOR_THEME`
};
export {
  analysisTemplateActionTypes as default
};
//# sourceMappingURL=AnalysisTemplateConstants.js.map
